import React from "react";
import "./ButtonDelete.css";
/**Firebase Imports**/
import { deleteDoc, doc, db } from "../../firebaseConfig";
/** **/

const ButtonDelete = ({
	id,
	description,
	className,
	mode,
	size,
	title,
	updateLinks,
	setUpdateLinks,
	URL,
	...props
}) => {
	const deleteLink = async () => {
		await deleteDoc(doc(db, "links", id));
		console.log("Link Deleted");
		setUpdateLinks(!updateLinks);
	};

	return (
		<div
			style={{ maxWidth: "520px" }}
			className={`relative Button ${mode} ${size} ${className}`}
			{...props}
		>
			<button
				className="w-full h-full"
				onClick={(e) => window.open(URL, "_blank")}
			>
				{title}
			</button>
			<img
				src={require("../../images/deleteIconRed.png")}
				alt="delete_icon"
				className="h-6 absolute top-0 right-1 -translate-x-1/2 translate-y-1/2 z-10"
				onClick={() => deleteLink()}
			/>
		</div>
	);
};

export default ButtonDelete;
